export default "__VITE_ASSET__BpZ_89TK__"